import { Box, Text } from '@bfa/common-ui';
import React from 'react';

import { GQLGbxOneClickLandingPage } from '../../../../gql.generated';
import { BoldedButton, GrayButton } from './GbxUpgradeButtonStyles';

const ExplanationAndNoThanks = ({
  landingChargeCopy,
  noThanksCta,
  fromCheckout,
  onNoThanks,
}: {
  landingChargeCopy: GQLGbxOneClickLandingPage['landingChargeCopy'];
  noThanksCta: GQLGbxOneClickLandingPage['noThanksCta'];
  fromCheckout?: boolean;
  onNoThanks: () => any;
}) => {
  return (
    <>
      {landingChargeCopy && (
        <Text as="p" fontSize="1.2rem" marginTop="1.2rem" marginBottom="0">
          {landingChargeCopy}
        </Text>
      )}
      {noThanksCta && fromCheckout && (
        <GrayButton
          link
          data-e2e-selector="no-thanks-button"
          onClick={onNoThanks}
        >
          {noThanksCta}
        </GrayButton>
      )}
    </>
  );
};

const GbxUpgradeButton = ({
  landingButtonCta,
  landingExplanation,
  landingChargeCopy,
  noThanksCta,
  onUpgradeSubmit,
  onNoThanks,
  fromCheckout,
  disabled = false,
}: {
  landingButtonCta: GQLGbxOneClickLandingPage['landingButtonCta'];
  landingExplanation: GQLGbxOneClickLandingPage['landingExplanation'];
  landingChargeCopy: GQLGbxOneClickLandingPage['landingChargeCopy'];
  noThanksCta: GQLGbxOneClickLandingPage['noThanksCta'];
  onUpgradeSubmit: () => any;
  onNoThanks: () => any;
  fromCheckout?: boolean;
  disabled?: boolean;
}) => {
  if (!landingButtonCta) return null;

  if (landingExplanation) {
    return (
      <>
        <Box
          backgroundColor="#F5EEE8"
          padding={['1.6rem', '2rem 1.6rem']}
          marginTop="1.2rem"
        >
          {landingExplanation && (
            <Text
              as="p"
              color="grayMedium"
              fontSize="1.2rem"
              dangerouslySetInnerHTML={{ __html: landingExplanation }}
            />
          )}
          <BoldedButton
            fullWidth
            marginTop="1.6rem"
            data-e2e-selector="upgrade-button"
            onClick={onUpgradeSubmit}
            disabled={disabled}
          >
            {landingButtonCta}
          </BoldedButton>
        </Box>
        <ExplanationAndNoThanks
          {...{ landingChargeCopy, noThanksCta, fromCheckout, onNoThanks }}
        />
      </>
    );
  }

  return (
    <>
      <BoldedButton
        fullWidth
        marginTop="1.5rem"
        data-e2e-selector="upgrade-button"
        onClick={onUpgradeSubmit}
      >
        {landingButtonCta}
      </BoldedButton>
      <ExplanationAndNoThanks
        {...{ landingChargeCopy, noThanksCta, fromCheckout, onNoThanks }}
      />
    </>
  );
};

export default GbxUpgradeButton;
